<template lang="pug">
  .comments-and-logs
    .comments(v-loader-overlay="progressCommentsAndLogs")
      //- диалог удаления комментария
      md-dialog(v-bind:md-active.sync="deleteDialog" md-theme="white")
        md-dialog-title {{removeMessage}}
        md-dialog-actions
          md-button.md-accent(@click="deleteComment") Удалить
          md-button.md-primary(@click="deleteDialog = false; commentIdToDelete = null") Отмена

      md-field.comment-field
        label {{$props.placeholder}}
        md-textarea.edit-comment(v-bind:disabled="sending" v-model="comment.text" v-validate="'required'" name="new_comment"  v-on:focus="showCommentButton = true" v-on:blur="hideCommentButton")
      .buttons
        z-button(
          @click="toggleDetails"
          v-if="this.feed && this.feed.length && !$props.only_comments"
          light
        ) {{(showDetails) ? 'Скрыть подробности' : 'Показать подробности'}}
        z-button(
          v-show="showCommentButton"
          v-on:click="saveComment(comment)"
          light
        ) Отправить

      .items(v-if="Object.keys(feed).length")
        .item(v-for="item in feed" v-bind:key="item.id" v-if="(item.type == 'log' && showDetails) || item.type == 'comment'" v-bind:class="{'visible': ((item.type == 'log' && showDetails) || item.type == 'comment')}")
          .comment(v-if="item.type == 'comment'")
              div.head
                .user(v-if="item.user") {{ item.user.login }}
                .user(v-else) Клиент
              div.body
                .md-layout-item.md-layout.md-alignment-top-right.actions(v-show="item.edit != 1 && $store.state.users.current.id == item.user_id")
                    md-button.small.md-dense.md-icon-button.edit(v-on:click.stop.prevent="editComment(item)"): md-icon edit
                    md-button.small.md-dense.md-icon-button.edit(v-on:click.stop.prevent="showDeleteDialog(item.id)"): md-icon delete
                .text(v-html="item.text" v-show="item.edit != 1" v-on:click="editComment(item)") {{ item.text }}
                md-field(v-bind:class="{ 'md-invalid': errors.has('edit_comment') }" v-show="item.edit === 1")
                  label Комментарий
                  md-textarea#edit-comment(v-bind:disabled="sending" v-model="item.text" name="edit_comment" v-bind:id="'comment-' + item.id")
                  md-button.md-dense.md-icon-button(v-on:click="saveComment(item)"): md-icon done
                  md-button.md-dense.md-icon-button.md-warn(v-on:click="item.edit = 0; item.text = item.oldText;"): md-icon close
              div.footer(v-if="item.created_at")
                .date {{ moment.tz(item.created_at, $root.defaultTimezone).fromNow() + ' (' + moment(item.created_at).tz($root.userTimezone).format('HH:mm DD.MM.YYYY') + ')'}}
                //.date {{ item.created_at }}
          .logs(v-show="showDetails" v-if="item.type == 'log'")
            .log
              //div.head(v-if="item.user && item.user.login")
                .user {{ item.user.login }}
              div.body(v-if="item.description")
                .text(v-html="item.description")
              div.footer(v-if="item.created_at")
                .date {{ moment.tz(item.created_at, $root.defaultTimezone).fromNow() + ' (' + moment(item.created_at).tz($root.userTimezone).format('HH:mm:ss DD.MM.YYYY') + ')'}}
</template>
<script>
  import ZButton from "@/components/ZButton"
  //moment.tz.setDefault('Asia/Vladivostok');
  export default {
    name: 'CommentsAndLogs',
    components: {
      ZButton
    },
    props: {
        module: {
            type: String,
            default: ''
        },
        entity: {
            type: String,
            default: ''
        },
        entity_id: {
            type: Number,
            default: 0
        },
        user_id: {
            type: Number,
            default: 0
        },
        only_comments: {
            type: Boolean,
            default: false
        },
        placeholder: {
            type: String,
            default: 'Комментарий'
        }
    },
    data() {
      return {
        feed: [],
        comment: {text: ''},
        sending: false,
        showCommentButton: false,
        deleteDialog: false,
        removeMessage: 'Удалить комментарий?',
        commentIdToDelete: null,
        showDetails: false
      }
    },
    created() {
      this.listeners();
      this.getComments();
    },
    watch: {
      '$props.entity_id'() {
        this.getComments();
      }
    },
    computed: {
        progressKey() {
          return 'load-comments-' +
              this.$props.module + '-' +
              this.$props.entity + '-' +
              this.$props.entity_id;
        },
        progressCommentsAndLogs() {
            return this.progressObj[this.progressKey];
        },
        progressObj() {
            return this.$store.state.progressObj;
        },
    },
    methods: {
      listeners() {
        this.$root.$on('post-comment', data => {
          if (this.$props.entity === data.entity && parseInt(this.$props.entity_id) === parseInt(data.entity_id)) this.getComments();
        });
      },
      toggleDetails() {
        this.showDetails = !this.showDetails;
      },
      showDeleteDialog(comment_id) {
        this.commentIdToDelete = comment_id;
        this.deleteDialog = true;
      },
      editComment(comment) {
        if (this.$store.state.users.current.id != comment.user_id) return;
        comment.edit = 1; 
        comment.oldText = comment.text;
      },
      //удаление комментария
      deleteComment() {
        this.deleteDialog = false;
        let comment_id = this.commentIdToDelete;
        this.$store.commit('showProgressBar', this.progressKey); this.sending = true; let self = this;
        //удаляем комментарий из задачи, к которому он прикреплён
        this.feed.forEach((comment, index) => {
          if (comment.id == comment_id) this.feed.splice(index, 1)
        });
        this.$store.dispatch('comments/deleteComment', { comment_id: comment_id }).then(response => {
          self.getComments(); this.sending = false; this.$store.commit('hideProgressBar', this.progressKey);
        }, response => {
          self.getComments(); this.sending = false; this.$store.commit('hideProgressBar', this.progressKey);
        });
      },

      //сохранение комментария
      saveComment(comment) {
        let self = this;
        if (comment.text.length > 0) {
          self.showCommentButton = false;
          comment.module_code = self.$props.module;

          this.$store.commit('showProgressBar', this.progressKey);
          this.sending = true;

          if (typeof comment.id == 'undefined') {
            comment.entity = self.$props.entity;
            comment.entity_id = self.$props.entity_id;
            self.comment = {text: ''};
            self.$store.dispatch('comments/addComment', { comment: comment }).then(response => {
              self.getComments(); this.sending = false; this.$store.commit('hideProgressBar', this.progressKey);
            }, response => {
              this.$store.commit('handleSnackError', [response, 6000, 'error']);
              this.$store.commit('hideProgressBar', this.progressKey); this.sending = false;
            });
          } else {
            this.$store.dispatch('comments/updateComment', { comment: comment }).then(response => {
              self.getComments(); this.sending = false; this.$store.commit('hideProgressBar', this.progressKey);
            }, response => {
              this.$store.commit('handleSnackError', [response, 6000, 'error']);
              this.$store.commit('hideProgressBar', this.progressKey); this.sending = false;
            });
            comment.edit = 0; comment.oldText = '';
          }
        }
      },

      getComments() {
        if (this.issetData()) {
          this.$store.commit('showProgressBar', this.progressKey);
          this.$store.dispatch('comments/getCommentsWithLogs', {
              entity: this.$props.entity,
              entity_id: this.$props.entity_id,
              user_id: this.$props.user_id,
              only_comments: (this.$props.only_comments) ? 1 : 0
          }).then(response => {
            if (!response) return;
            this.$store.commit('hideProgressBar', this.progressKey);
            let feed = response; this.moment.locale('ru');
            //преобразовываем формат даты
            feed.forEach(item => {
              //item.created_at = this.moment(item.created_at, 'YYYY-MM-DD HH:mm:ss').fromNow();
              item.edit = 0;
            });
            this.feed = feed;
          }, response => {
            this.$store.commit('hideProgressBar', this.progressKey);
            this.commit('handleSnackError', [response, 6000, 'error']);
          });
        }
      },

      //скрытие кнопки комментариев
      hideCommentButton() {
        if (this.comment.text.length == 0) this.showCommentButton = false
      },

      issetData() {
          return (
          this.$props.entity_id &&
          this.$props.module &&
          this.$props.entity &&
          typeof this.$props.entity_id === 'number' &&
          typeof this.$props.module === 'string' &&
          typeof this.$props.entity === 'string'
        );
      }
    }
  }
</script>
<style lang="sass">
  .comments-and-logs
    .logs .log, .comments .comment
        font-size: 12px
        margin-left: 30px
        position: relative
        &::before
          content: ''
          height: 100%
          width: 1px
          background-color: #E5E5E5
          position: absolute
          top: 20px
          left: -20px
        &::after
          content: ''
          position: absolute
          top: 0
          left: -30px
          width: 20px
          height: 20px
          border-radius: 50%
          color: #fff
          font-family: 'Material Icons'
          display: flex
          align-items: center
          justify-content: center
          font-size: 12px
        .price
          font-weight: bold
          background: yellow
          padding: 2px 4px
          border-radius: 4px
        .body
          margin-bottom: 4px
        .footer
          font-size: 10px
          line-height: 12px
          color: #888
    .items
      .item.visible:last-child
        .log, .comment
          &::before
            display: none
    .logs
      .log
        font-size: 12px
        line-height: 20px
        margin-bottom: 15px
        &::after
          background-color: #2196F3
          content: 'settings'
        ul
          list-style: none
          padding: 0 !important
          li::before
            content: '\2022'
            color: #2196F3
            display: inline-block
            padding-right: 6px
    .comments
      .buttons
        display: flex
        justify-content: space-between
        .z-button
          flex-grow: 0
          width: auto
          padding: 0 40px
      .items
        margin-top: 20px
        .user
          font-weight: bold
      .comment
        margin-bottom: 15px
        position: relative
        &::after
          background-color: #5DA36D
          content: 'comment'
        .head
          margin-bottom: 4px
        .text
          padding: 10px
          border: 1px solid #E5E5E5
          border-radius: 3px
        .actions
          position: absolute
          top: calc(50% - 12px)
          right: 10px
          z-index: 10
        .user
          font-weight: bold
        .actions
          opacity: 0
          transition: all .3s
        &:hover .actions
          opacity: 1
</style>



// WEBPACK FOOTER //
// CommentsAndLogs.vue?3e538a89